import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationsService } from 'src/app/Service/publications.service';
declare var $: any;
import * as _ from 'lodash'

@Component({
  selector: 'app-communiques-presse',
  templateUrl: './communiques-presse.component.html',
  styleUrls: ['./communiques-presse.component.scss']
})
export class CommuniquesPresseComponent implements OnInit {

  constructor(private global: Global, private service: PublicationsService, private route: ActivatedRoute,private translate: TranslateService) { }

  slick: any = null;
  dataPress;
  dataPress1;

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.dataPress = [];
      this.service.getPress(lg.url).subscribe(data => {
        this.dataPress = data["value"];
        this.dataPress1 = _.chunk(data["value"],3) ;
        if (this.slick != null) {
          this.reload();
        } else {
          setTimeout(() => this.slickContent(lg), 100);
        }
      })
    })
  }

  slickContent(lg) {
    this.slick = $('.slickContent').dataTable({
      data: this.dataPress1,
      columns: [
        {
          data: 'Title',
          render: (data, type, row) => {
            return this.returnhtml(row);
          }
        }
        // ,
        // {
        //   data: 'Title',
        //   render: (data, type, row) => {
        //     return this.returnhtml(row);
        //   }
        // },
        // {
        //   data: 'Title',
        //   render: (data, type, row) => {
        //     return this.returnhtml(row);
        //   }
        // }
      ],
      "language": {
        "paginate": {
          "previous": '«',
          "next": '»'
        }
      },
      "lengthMenu": [2],
      "ordering": false,
      "searching": false,
      "info": false,
      "lengthChange": false
    });


    // if (lg.code != "ar") {
    //   this.slick = $('.slickContent').slick({
    //     slidesPerRow: 3,
    //     rows: 2,
    //     infinite: true,
    //     slidesToScroll: 3,
    //     dots: true,
    //     responsive: [
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           slidesPerRow: 2,
    //           rows: 2,
    //           slidesToScroll: 2,
    //           infinite: true,
    //         }
    //       },
    //       {
    //         breakpoint: 600,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         }
    //       },
    //       {
    //         breakpoint: 480,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         }
    //       }
    //     ]
    //   });
    // }
    // else {
    //   this.slick = $('.slickContent').slick({
    //     rtl: true,
    //     infinite: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 3,
    //     dots: true,
    //     responsive: [
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 2,
    //           infinite: true,
    //         }
    //       },
    //       {
    //         breakpoint: 600,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         }
    //       },
    //       {
    //         breakpoint: 480,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         }
    //       }
    //     ]
    //   });
    // }
  }
  reload() {
    $('.slickContent').DataTable().clear();
    $('.slickContent').DataTable().rows.add(this.dataPress);
    $('.slickContent').DataTable().columns.adjust().draw();
  }
  returnhtml(row){
    let result='<div class="row slickpress">'
    row.forEach(p => {
      result+=
      '<div  class="col-md-4" style="margin-bottom: 10px; min-height: 200px;">'+
        '<div class="block-actu">'+
          '<div class="date-actu">'+this.converteDate(p?.PressDate)+'</div>'+
          '<h3 class="titre-presse">'+p?.Title?.substr(0,95)+'...</h3>'+
          //'<p class="actu-resume">'+p?.PressDescription?.substr(0,200)+'...</p>'+
          '<a class="btn btn-info pl-5" href="'+p.FileRef+'"><span class="icon-download"></span>'+this.translate.instant("Statistiques.Telecharger")+'</a>'+
        '</div>'+
      '</div>'
    });
    return result+''
    
  }
  converteDate(d: string) {
    return this.global.formattedDate(d);
  }
}
